import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import styles from './index.module.css';

const NewsEventsDetailPage = () => {
  const { slug } = useParams();
  const { find, meta, loaded } = usePageContent(`news-and-events/${slug}`);
  const seo = meta?.seo;
  const c = find('newsArticle');
  useTitle(seo?.title || c?.title);
  useMeta(seo);

  if (!loaded) {
    return (
      <div id="content">
        <div className="content-holder content-holder--indented">
          <div className={styles.newsArticleLoading} />
        </div>
      </div>
    );
  }

  if (!c) {
    return (
      <div id="content">
        <div className="content-holder content-holder--indented">
          <p>Article not found. <Link to="/news-and-events">← Back to News &amp; Events</Link></p>
        </div>
      </div>
    );
  }

  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.title}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        {c.date && <div className={styles.newsArticleDate}>{c.date}</div>}
        <div
          className={styles.newsArticleBody}
          dangerouslySetInnerHTML={{ __html: c.bodyHtml }}
        />
      </div>
    </div>
  );
};

export default NewsEventsDetailPage;
